import React, { useEffect, useState } from 'react';
import SiteShell, { Reveal } from './SiteShell';
import api from '../api/client';

const inputStyle = {
  width: '100%', padding: '13px 14px', borderRadius: 12, border: '1px solid #DFE1E8',
  fontSize: 15, fontFamily: 'inherit', background: '#fff', marginTop: 6,
};
const labelStyle = { fontSize: 13.5, fontWeight: 700, color: '#1B1D28' };

export default function DeleteAccount() {
  const [s, setS] = useState({});
  const [form, setForm] = useState({ name: '', mobile: '', email: '', reason: '' });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => { api.get('/settings/public').then((d) => setS(d || {})).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (form.mobile.replace(/\D/g, '').length !== 10) {
      return setErr('Please enter your registered 10-digit mobile number.');
    }
    setBusy(true);
    try {
      const d = await api.post('/account/deletion-request', form);
      setDone(d?.message || 'Request received.');
    } catch (e2) {
      setErr(e2.message || 'Could not submit. Please email us instead.');
    }
    setBusy(false);
  };

  return (
    <SiteShell settings={s}>
      <div className="wrap doc">
        <Reveal>
          <h1>Delete your account</h1>
          <p className="upd">Request deletion of your {s.companyName || 'Narayan'} account and associated data.</p>

          <h2>What gets deleted</h2>
          <ul>
            <li>Your profile — name, mobile number, email and addresses.</li>
            <li>Your saved bank details and referral information.</li>
            <li>KYC documents and photos (for service professionals).</li>
            <li>Notifications and support tickets linked to your account.</li>
          </ul>

          <h2>What we must keep</h2>
          <ul>
            <li>Booking and payment/invoice records, which Indian tax law requires us to retain for up to 8 financial years. These are kept in a restricted, anonymised form wherever possible.</li>
          </ul>

          <h2>How long it takes</h2>
          <p>We verify and action deletion requests within <strong>30 days</strong>, and confirm by email or SMS once complete.</p>

          <h2>Request deletion</h2>
          {done ? (
            <div style={{ background: '#E5F5EE', border: '1px solid #1E9E6A', color: '#146c4b', borderRadius: 12, padding: 18, fontSize: 15, fontWeight: 600 }}>
              ✅ {done}
            </div>
          ) : (
            <form onSubmit={submit} style={{ display: 'grid', gap: 16, maxWidth: 520, marginTop: 8 }}>
              <label style={labelStyle}>Full name
                <input style={inputStyle} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" />
              </label>
              <label style={labelStyle}>Registered mobile number *
                <input style={inputStyle} value={form.mobile} inputMode="numeric" placeholder="10-digit number"
                  onChange={(e) => setForm({ ...form, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })} />
              </label>
              <label style={labelStyle}>Email
                <input style={inputStyle} type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" />
              </label>
              <label style={labelStyle}>Reason (optional)
                <textarea style={{ ...inputStyle, height: 96, resize: 'vertical' }} value={form.reason}
                  onChange={(e) => setForm({ ...form, reason: e.target.value })} placeholder="Tell us why you're leaving" />
              </label>
              {err ? <div style={{ color: '#C1121F', fontSize: 14, fontWeight: 600 }}>{err}</div> : null}
              <button className="btn btn-primary btn-lg" type="submit" disabled={busy} style={{ justifySelf: 'start' }}>
                {busy ? 'Submitting…' : 'Request account deletion'}
              </button>
            </form>
          )}

          <h2>Prefer to contact us?</h2>
          <p>
            {s.supportEmail
              ? <>Email <a href={`mailto:${s.supportEmail}?subject=Delete%20my%20account`} style={{ color: '#C1121F', fontWeight: 700 }}>{s.supportEmail}</a></>
              : 'Email our support team'}
            {s.companyPhone ? <> or call <a href={`tel:${s.companyPhone}`} style={{ color: '#C1121F', fontWeight: 700 }}>{s.companyPhone}</a></> : null}
            {' '}from your registered number.
          </p>
        </Reveal>
      </div>
    </SiteShell>
  );
}
